module.exports = __webpack_public_path__ + "static/media/1001365DO.0bc32dc4.jpg";